import { ITooltipMessages } from '../../interfaces/ITooltipMessages';

const rejectedFromIdentity: string = 'Your documents have not met our criteria. ' +
  'Please proceed to BF Identity to resubmit below after reviewing the reason for rejection.';

const tooltipIndividualMessages: ITooltipMessages = {
  verification: {
    incomplete: 'Some of your documents or income data have ' +
      'not been submitted / verified. Please submit missing documents.',
    awaiting_verification: 'Your profile documents and income data have been' +
      ' submitted and will be reviewed in the next 5 working days or sooner.',
    rejected: 'One or more of your documents has not met our criteria.' +
      ' Please resubmit below after reviewing the reason for rejection.',
    unverified: 'In order to invest and trade on our platform you need to verify your identity.',
    part_verified: 'Your company documents have been verified. Not all company' +
      ' collaborators have been verified yet. Please request or upload missing documents from the members below.',
    expired: 'The document which supported your verification status has expired. ' +
      'Please update or reupload the required documents to reinstate your full investment rights.',
    aml_failed: 'Your profile has failed an automated AML check. Please contact BF Support for more info.',
    pending: 'Your verification request is still being reviewed by our support team.',
  },
  certification: {
    self_certified: 'Your have self-certified yourself as a qualifying investor but your certification' +
      ' document has not been submitted / verified.',
    uncertified: 'Please certify your investor status below to invest and trade on our platform.',
    awaiting_certification: 'Your certification document has been submitted and ' +
      ' will be reviewed in the next 5 working days or sooner.',
    rejected: rejectedFromIdentity,
    rejected_certification: 'Your documents has not met our criteria. Please resubmit' +
      ' below after reviewing the reason for rejection.',
    waiting: 'US Investor. You are waiting 30 days to be able to invest.',
    waited_30_days: 'You will only be able to view certain pitches marked 506(b). To gain access to all ' +
      ' pitches that are accepting US residents please fully certify your account by submitting further documents.',
    expired: 'The document which supported your certification status has expired. ' +
      'Please update or reupload the required documents to reinstate your full investment rights.',
    pending: 'Your certification request is still being reviewed by our support team.',
  },
};

const tooltipOrganizationMessages: ITooltipMessages = {
  verification: {
    incomplete: 'Some of your organisation documents or data have ' +
      'not been submitted / verified. Please submit missing documents.',
    awaiting_verification: 'Your profile documents and income data have been' +
      ' submitted and will be reviewed in the next 5 working days or sooner.',
    rejected: 'One or more of your documents has not met our criteria.' +
      ' Please proceed to BF Identity to resubmit after reviewing the reason for rejection.',
    unverified: 'In order to invest and trade on our platform you need to verify' +
      ' your identity and the organisation registration details.',
    part_verified: 'Your company documents have been verified. Not all company' +
      ' collaborators have been verified yet. Please request or upload missing documents from the members below.',
    expired: 'The document which supported your verification status has expired. ' +
      'Please update or reupload the required documents to reinstate your full investment rights.',
    aml_failed: 'Your profile has failed an automated AML check. Please contact BF Support for more info.',
    pending: 'Your verification request is still being reviewed by our support team.',
  },
  certification: {
    self_certified: 'Your have self-certified yourself and your organisation as a ' +
      'qualifying investor but your certification' +
      ' document has not been submitted / verified. Please proceed to BF Identity to submit this missing document.',
    uncertified: 'Please certify your investor status below to invest and trade on our platform.',
    awaiting_certification: 'Your certification document has been submitted and ' +
      ' will be reviewed in the next 5 working days or sooner.',
    rejected: rejectedFromIdentity,
    rejected_certification: rejectedFromIdentity,
    waiting: 'US Investor. You are waiting 30 days to be able to invest.',
    waited_30_days: 'You will only be able to view certain pitches marked 506(b). To gain access to all ' +
      ' pitches that are accepting US residents please fully certify your account by submitting further documents.',
    expired: 'The document which supported your certification status has expired. ' +
      'Please update or reupload the required documents to reinstate your full investment rights.',
    pending: 'Your certification request is still being reviewed by our support team.',
  },
};

export const getTooltipMessages = (isOrganizational: boolean): ITooltipMessages => {
  if (isOrganizational) return tooltipOrganizationMessages;
  return tooltipIndividualMessages;
};
